import React from 'react';
import { Avatar, AvatarProps } from '@mui/material';
import { getIconById, getDefaultIcon } from '../../utils/profileIcons';

interface UserAvatarProps extends Omit<AvatarProps, 'children'> {
  profileIcon?: string;
  username?: string;
  size?: number;
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  profileIcon,
  username,
  size = 40,
  ...avatarProps
}) => {
  // Get icon data from profileIcon ID
  const iconData = profileIcon ? getIconById(profileIcon) : null;
  const defaultIcon = getDefaultIcon();

  // If profileIcon is set and found, use the emoji
  if (iconData) {
    return (
      <Avatar
        {...avatarProps}
        sx={{
          width: size,
          height: size,
          fontSize: `${size * 0.6}px`,
          bgcolor: 'primary.main',
          ...avatarProps.sx
        }}
      >
        {iconData.emoji}
      </Avatar>
    );
  }

  // Fallback to first letter of username or default icon
  if (username) {
    return (
      <Avatar
        {...avatarProps}
        sx={{
          width: size,
          height: size,
          fontSize: `${size * 0.4}px`,
          bgcolor: 'primary.main',
          ...avatarProps.sx
        }}
      >
        {username.charAt(0).toUpperCase()}
      </Avatar>
    );
  }

  // Ultimate fallback to default icon
  return (
    <Avatar
      {...avatarProps}
      sx={{
        width: size,
        height: size,
        fontSize: `${size * 0.6}px`,
        bgcolor: 'primary.main',
        ...avatarProps.sx
      }}
    >
      {defaultIcon.emoji}
    </Avatar>
  );
};

export default UserAvatar;
